import { blue500, deepOrange500, green500, indigo500, lightGreen500, purple500, teal500, redA700 } from '../../MaterialColorPicker/colors';

export const NUCLEOS_CUADRO_DE_MANDO = [
  {
    nombre: 'N1S2',
    color: teal500,
    sector: 'S2',
    pos1: {
      x: 9,
      y: 3
    },
    pos2: {
      x: 15,
      y: 3
    },
    pos3: {
      x: 15,
      y: 9
    },
    pos4: {
      x: 9,
      y: 9
    }
  }, {
    nombre: 'N2S2',
    color: lightGreen500,
    sector: 'S2',
    pos1: {
      x: 21,
      y: 9
    },
    pos2: {
      x: 27,
      y: 9
    },
    pos3: {
      x: 27,
      y: 15
    },
    pos4: {
      x: 21,
      y: 15
    }
  }, {
    nombre: 'N3S2',
    color: blue500,
    sector: 'S2',
    pos1: {
      x: 33,
      y: 9
    },
    pos2: {
      x: 39,
      y: 9
    },
    pos3: {
      x: 39,
      y: 15
    },
    pos4: {
      x: 33,
      y: 15
    }
  }, {
    nombre: 'N1S3',
    color: indigo500,
    sector: 'S3',
    pos1: {
      x: 21,
      y: 9
    },
    pos2: {
      x: 27,
      y: 9
    },
    pos3: {
      x: 27,
      y: 15
    },
    pos4: {
      x: 21,
      y: 15
    }
  }, {
    nombre: 'N2S3',
    color: deepOrange500,
    sector: 'S3',
    pos1: {
      x: 33,
      y: 3
    },
    pos2: {
      x: 39,
      y: 3
    },
    pos3: {
      x: 39,
      y: 9
    },
    pos4: {
      x: 33,
      y: 9
    }
  }, {
    nombre: 'N3S3',
    color: green500,
    sector: 'S3',
    pos1: {
      x: 45,
      y: 3
    },
    pos2: {
      x: 51,
      y: 3
    },
    pos3: {
      x: 51,
      y: 9
    },
    pos4: {
      x: 45,
      y: 9
    }
  }, {
    nombre: 'N4S3',
    color: purple500,
    sector: 'S3',
    pos1: {
      x: 57,
      y: 9
    },
    pos2: {
      x: 57,
      y: 15
    },
    pos3: {
      x: 51,
      y: 15
    },
    pos4: {
      x: 54,
      y: 12
    }
  }, {
    nombre: 'SANITARIOS',
    color: redA700,
    sector: 'S1',
    pos1: {
      x: 87,
      y: 9
    },
    pos2: {
      x: 93,
      y: 9
    },
    pos3: {
      x: 93,
      y: 15
    },
    pos4: {
      x: 87,
      y: 15
    }
  }
]

export const COLUMNS_CONSULTA_TOTAL_ESPACIO_SILO_CEREAL = [
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value: string) => !value || value.trim() === 'UNDEF' ? 'Sin Definir' : value
    }
  },
  {
    name: 'netoTotalBaseTrigo',
    label: 'Neto Base Trigo [tn]',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value: any) => value ? +Number(value).toFixed(2) : 0
    }
  },
  {
    name: 'netoTotalBaseActual',
    label: 'Neto Base Actual [tn]',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value: any) => value ? +Number(value).toFixed(2) : 0
    }
  },
  {
    name: 'pesoNetoTotal',
    label: 'Peso Neto [tn]',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value: any) => value ? +Number(value).toFixed(2) : 0
    }
  },
  {
    name: 'espacioNetoTotal',
    label: 'Espacio Neto [tn]',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value: any) => value ? +Number(value).toFixed(2) : 0
    }
  },
  {
    name: 'metrosDeVacio',
    label: 'Mts de Vacio',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value: any) => value ? +Number(value).toFixed(2) : 0
    }
  },
  {
    name: 'espacionTotalCamiones',
    label: 'Espacio Camiones',
    options: {
      filter: true,
      sort: true
    }
  }
]

export const COLUMNS_CONSULTA_TOTAL_ESPACIO_SILO_CEREAL_TO_PRINT = [
  {
    name: 'cereal',
    label: 'Cereal',
    mantenerCase: true
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    mantenerCase: true
  },
  {
    name: 'pesoNetoTotalBaseTrigo',
    label: 'Neto Base Trigo [tn]',
    mantenerCase: true
  },
  {
    name: 'pesoNetoTotalBaseVigente',
    label: 'Neto Base Actual [tn]',
    mantenerCase: true
  },
  {
    name: 'pesoNetoBaseVigente',
    label: 'Peso Neto [tn]',
    mantenerCase: true
  },
  {
    name: 'espacioNetoTotal',
    label: 'Espacio Neto [tn]',
    mantenerCase: true
  },
  {
    name: 'metrosDeVacio',
    label: 'Mts de Vacio',
    mantenerCase: true
  },
  {
    name: 'espacionTotalCamiones',
    label: 'Espacio Camiones',
    mantenerCase: true
  }
]

export const COLUMNS_CONSULTA_TOTAL_ESPACIO_SILO_CEREAL_POR_LINEA = [
  {
    name: 'linea',
    label: 'Linea',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'netoTotalBaseTrigo',
    label: 'Neto Base Trigo [tn]',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value: any) => value ? +Number(value).toFixed(2) : 0
    }
  },
  {
    name: 'netoTotalBaseActual',
    label: 'Neto Base Actual [tn]',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value: any) => value ? +Number(value).toFixed(2) : 0
    }
  },
  {
    name: 'pesoNetoTotal',
    label: 'Peso Neto [tn]',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value: any) => value ? +Number(value).toFixed(2) : 0
    }
  },
  {
    name: 'espacioNetoTotal',
    label: 'Espacio Neto [tn]',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value: any) => value ? +Number(value).toFixed(2) : 0
    }
  },
  {
    name: 'espacionTotalCamiones',
    label: 'Espacio Camiones',
    options: {
      filter: true,
      sort: true
    }
  }
]

export const COLUMNS_CONSULTA_TOTAL_ESPACIO_SILO_CEREAL_POR_LINEA_PROGRESS_BARS = [
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'l6S12',
    label: 'L6 S1-2',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value: any) => value ? +Number(value).toFixed(2) : 0
    }
  },
  {
    name: 'l5S12',
    label: 'L5 S1-2',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value: any) => value ? +Number(value).toFixed(2) : 0
    }
  },
  {
    name: 'l7S12',
    label: 'L7 S1-2',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value: any) => value ? +Number(value).toFixed(2) : 0
    }
  },
  {
    name: 'l6S3',
    label: 'L6 S3',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value: any) => value ? +Number(value).toFixed(2) : 0
    }
  },
  {
    name: 'l5S3',
    label: 'L5 S3',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value: any) => value ? +Number(value).toFixed(2) : 0
    }
  },
  {
    name: 'l7S3',
    label: 'L7 S3',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value: any) => value ? +Number(value).toFixed(2) : 0
    }
  },
  {
    name: 's5',
    label: 'S5',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value: any) => value ? +Number(value).toFixed(2) : 0
    }
  },
  {
    name: 'pesoNetoTotal',
    label: 'Peso Neto [tn]',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value: any) => value ? +Number(value).toFixed(2) : 0
    }
  }
]

export const COLUMNS_CONSULTA_TOTAL_ESPACIO_SILO_CEREAL_POR_LINEA_PROGRESS_BARS_TO_PRINT = [
  {
    name: 'cereal',
    label: 'Cereal',
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
  },
  {
    name: 'l6S12',
    label: 'L6 S1-2',
  },
  {
    name: 'l5S12',
    label: 'L5 S1-2',
  },
  {
    name: 'l7S12',
    label: 'L7 S1-2',
  },
  {
    name: 'l6S3',
    label: 'L6 S3',
  },
  {
    name: 'l5S3',
    label: 'L5 S3',
  },
  {
    name: 'l7S3',
    label: 'L7 S3',
  },
  {
    name: 's5',
    label: 'S5',
  },
  {
    name: 'pesoNetoTotal',
    label: 'Peso Neto [tn]',
  }
]